import { CommonModule } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { NavigationComponent } from 'src/app/shared/header/navigation.component';
import { SidebarComponent } from 'src/app/shared/sidebar/sidebar.component';
import { NgbDropdownConfig, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from 'src/app/profile/profile.service';
import { ProfileSharedService } from 'src/app/profile/profile-shared.service';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-full-layout',
  standalone: true,
  imports: [RouterModule, SidebarComponent, NavigationComponent, CommonModule, NgbCollapseModule, NgbDropdownModule],
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss'],
  providers: [NgbDropdownConfig],
})
export class FullComponent implements OnInit {
  public isCollapsed = false;
  public innerWidth = 0;
  public defaultSidebar = '';
  public showMobileMenu = false;
  public expandLogo = false;
  public sidebartype = 'full';
  public userName = '';

  constructor(
    public router: Router,
    config: NgbDropdownConfig,
    private profileService: ProfileService,
    private profileSharedService: ProfileSharedService,
    private authService: AuthService,
  ) {
    config.placement = 'top-start';
    config.autoClose = false;
  }

  ngOnInit() {
    const islogined = this.authService.isAuthenticated();
    if (this.router.url === '/') {
      if (islogined) {
        this.router.navigate(['/dashboard']);
      } else {
        this.router.navigate(['/login']);
      }
    }
    this.defaultSidebar = this.sidebartype;
    this.handleSidebar();
    this.getUserProfileData();
    this.profileSharedService.userDetail.subscribe((event) => {
      if (event) {
        this.getUserProfileData();
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.handleSidebar();
  }

  Logo() {
    this.expandLogo = !this.expandLogo;
  }

  handleSidebar() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1170) {
      this.sidebartype = 'full';
    } else {
      this.sidebartype = this.defaultSidebar;
    }
  }

  onLogoutClick() {
    this.authService.logout();
  }

  toggleSidebarType() {
    switch (this.sidebartype) {
      case 'full':
        this.sidebartype = 'mini-sidebar';
        break;
      case 'mini-sidebar':
        this.sidebartype = 'full';
        break;
      default:
    }
  }

  getUserProfileData() {
    this.profileService.getUserProfileData().subscribe(
      (userDetails) => {
        userDetails = {
          ...userDetails,
          entityRoleId: userDetails.entityRoleId.split('-')[0],
        };
        this.userName = `${userDetails.firstName} ${userDetails.lastName}`;
        localStorage.setItem('userData', JSON.stringify(userDetails));
      },
      (error) => {
        console.error(error);
      },
    );
  }
}
